export const MOCK_DEPARTMENTS = [
  { departmentId: 1, departmentName: "General Medicine" },
  { departmentId: 2, departmentName: "Orthopaedics" },
  { departmentId: 3, departmentName: "Paediatrics" },
  { departmentId: 4, departmentName: "Gynaecology" },
  { departmentId: 5, departmentName: "Surgery" },
];

export const MOCK_DOCTORS = [
  { doctorId: 1, doctorName: "Dr Mahesh Mandora" },
  { doctorId: 2, doctorName: "Dr. Tukaram Aute" },
  { doctorId: 3, doctorName: "Dr Anita Rao" },
  { doctorId: 4, doctorName: "Dr. Sanjeev Kulkarni" },
  { doctorId: 5, doctorName: "Dr Prasad Deshmukh" },
];

export const MOCK_PATIENT_SEARCH_OPTIONS = [
  {
    patientId: 101,
    patientName: "Mr Dhyanshwar Dhobale",
    gender: "Male",
    age: "32",
    contact: "7664385789",
    uhid: "7758",
  },
  {
    patientId: 102,
    patientName: "Mrs Priya Sharma",
    gender: "Female",
    age: "45",
    contact: "9988776655",
    uhid: "7750",
  },
  {
    patientId: 103,
    patientName: "Mr Patient Three",
    gender: "Male",
    age: "8",
    contact: "9876543210",
    uhid: "7760",
  },
  {
    patientId: 104,
    patientName: "VIJAY A KULKARNI",
    gender: "Male",
    age: "58",
    contact: "9123456780",
    uhid: "UHID0256489",
  },
];

export const getMockMedicalRecordQueue = () => [
  {
    patientId: 101,
    patientName: "Mr Dhyanshwar Dhobale",
    age: "32",
    gender: "Male",
    department: "General Medicine",
    doctor: "Dr. Tukaram Aute",
    departmentId: 1,
    doctorId: 2,
    visitDate: "2026-06-13",
    tokenNo: "T-101",
    visitNo: "OP-4412",
  },
  {
    patientId: 102,
    patientName: "Mrs Priya Sharma",
    age: "45",
    gender: "Female",
    department: "Gynaecology",
    doctor: "Dr Anita Rao",
    departmentId: 4,
    doctorId: 3,
    visitDate: "2026-06-13",
    tokenNo: "T-102",
    visitNo: "OP-4413",
  },
  {
    patientId: 103,
    patientName: "Mr Patient Three",
    age: "8",
    gender: "Male",
    department: "Paediatrics",
    doctor: "Dr Mahesh Mandora",
    departmentId: 3,
    doctorId: 1,
    visitDate: "2026-06-13",
    tokenNo: "T-103",
    visitNo: "OP-4414",
  },
  {
    patientId: 104,
    patientName: "VIJAY A KULKARNI",
    age: "58",
    gender: "Male",
    department: "Orthopaedics",
    doctor: "Dr. Sanjeev Kulkarni",
    departmentId: 2,
    doctorId: 4,
    visitDate: "2026-06-13",
    tokenNo: "T-104",
    visitNo: "OP-4415",
  },
  {
    patientId: 105,
    patientName: "Mrs Lata Kulkarni",
    age: "52",
    gender: "Female",
    department: "General Medicine",
    doctor: "Dr Prasad Deshmukh",
    departmentId: 1,
    doctorId: 5,
    visitDate: "2026-06-12",
    tokenNo: "T-105",
    visitNo: "OP-4408",
  },
  {
    patientId: 106,
    patientName: "Mr Rajesh Kumar",
    age: "55",
    gender: "Male",
    department: "Surgery",
    doctor: "Dr. Sanjeev Kulkarni",
    departmentId: 5,
    doctorId: 4,
    visitDate: "2026-06-13",
    tokenNo: "T-106",
    visitNo: "OP-4416",
  },
  {
    patientId: 107,
    patientName: "Ms Anjali Desai",
    age: "29",
    gender: "Female",
    department: "General Medicine",
    doctor: "Dr Mahesh Mandora",
    departmentId: 1,
    doctorId: 1,
    visitDate: "2026-06-11",
    tokenNo: "T-107",
    visitNo: "OP-4401",
  },
  {
    patientId: 108,
    patientName: "Mr Suresh Patel",
    age: "62",
    gender: "Male",
    department: "Orthopaedics",
    doctor: "Dr. Tukaram Aute",
    departmentId: 2,
    doctorId: 2,
    visitDate: "2026-06-13",
    tokenNo: "T-108",
    visitNo: "OP-4417",
  },
];
